import { FC, useState } from "react";
import { HiQuestionMarkCircle } from "react-icons/hi";
import { HelpPopup } from "@components";
import { useTranslation } from "react-i18next";

export interface HelpLabelProps {
  title?: string;
  content: string | React.ReactNode;
  className?: string;
  showText?: boolean;
}

export const HelpLabel: FC<HelpLabelProps> = ({
  title,
  content,
  className = "",
  showText = true,
}) => {
  const { t } = useTranslation("common");
  const [isOpen, setIsOpen] = useState(false);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  // Use provided title or fall back to translation
  const labelText = title || t("help");

  return (
    <div className="relative inline-block">
      <button
        onClick={togglePopup}
        className={`flex items-center gap-1.5 px-2.5 py-1 bg-purple-100 hover:bg-purple-200 text-purple-700 font-medium rounded-full transition-colors duration-200 ${className}`}
        aria-label={t("help.open_help")}
      >
        <span style={{ fontSize: "13px" }}>{labelText}</span>
        <HiQuestionMarkCircle className="h-4 w-4 text-purple-600" />
      </button>

      {isOpen && (
        <HelpPopup content={content} onClose={() => setIsOpen(false)} />
      )}
    </div>
  );
};
